(function () {
  function leseWarenkorb() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (res) {
      return res.json();
    });
  }

  function aendereMenge(line, quantity) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: line, quantity: quantity })
    });
  }

  function korrigiereWarenkorb() {
    return leseWarenkorb().then(function (cart) {
      var items = cart.items;
      var mengenProVariante = {};

      // Menge jeder "normalen" Variante zählen (alle Zeilen OHNE Geschenk-Eigenschaft)
      items.forEach(function (item) {
        if (!item.properties || !item.properties._gift_for_variant_id) {
          var id = item.variant_id;
          mengenProVariante[id] = (mengenProVariante[id] || 0) + item.quantity;
        }
      });

      // Rückwärts durchgehen, damit sich Positionsnummern beim Ändern nicht verschieben
      for (var i = items.length - 1; i >= 0; i--) {
        var item = items[i];
        if (item.properties && item.properties._gift_for_variant_id) {
          var hauptVariantId = item.properties._gift_for_variant_id;
          var erlaubteMenge = mengenProVariante[hauptVariantId] || 0;

          if (item.quantity > erlaubteMenge || erlaubteMenge === 0) {
            aendereMenge(i + 1, erlaubteMenge);
          }
        }
      }
    });
  }

  function steuereExpressButtons() {
    leseWarenkorb().then(function (cart) {
      var hatGeschenk = cart.items.some(function (item) {
        return item.properties && item.properties._gift_for_variant_id;
      });

      var expressButtons = document.querySelectorAll(
        '.cart__dynamic-checkout-buttons, .additional-checkout-buttons'
      );

      expressButtons.forEach(function (el) {
        el.style.display = hatGeschenk ? 'none' : '';
      });
    });
  }

  var laeuftGerade = false;

  function pruefungKomplett() {
    if (laeuftGerade) return Promise.resolve();
    laeuftGerade = true;

    return korrigiereWarenkorb()
      .then(function () {
        steuereExpressButtons();
        laeuftGerade = false;
      })
      .catch(function () {
        laeuftGerade = false;
      });
  }

  // Nach jeder Warenkorb-Änderung kurz warten, dann prüfen
  var originalFetch = window.fetch;
  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';

    return originalFetch.apply(this, arguments).then(function (response) {
      if (
        url.indexOf('/cart/change.js') !== -1 ||
        url.indexOf('/cart/add.js') !== -1 ||
        url.indexOf('/cart/update.js') !== -1 ||
        url.indexOf('/cart/clear.js') !== -1
      ) {
        setTimeout(pruefungKomplett, 150);
      }
      return response;
    });
  };

  // Regelmäßige Kontrolle als Sicherheitsnetz
  setInterval(pruefungKomplett, 800);
  document.addEventListener('DOMContentLoaded', pruefungKomplett);
  window.addEventListener('pageshow', pruefungKomplett);

  // Checkout-Button absichern: vor der Weiterleitung eine letzte Prüfung erzwingen
  function sichereKlick(selector) {
    document.addEventListener(
      'click',
      function (event) {
        var target = event.target.closest(selector);
        if (!target) return;

        if (target.dataset.geschenkGeprueft === 'true') {
          target.dataset.geschenkGeprueft = '';
          return; // Prüfung schon erledigt -> Klick ganz normal durchlassen
        }

        event.preventDefault();
        event.stopPropagation();

        pruefungKomplett().then(function () {
          target.dataset.geschenkGeprueft = 'true';
          target.click();
        });
      },
      true // Capture-Phase: greift vor anderen Skripten
    );
  }

  sichereKlick('#checkout, #CartDrawer-Checkout, [name="checkout"]');
})();